module.exports = __webpack_public_path__ + "img/download-inventory-big-hover.35252fbe.png";